import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';
import {BehaviorSubject, zip} from 'rxjs';
import {DbReaderService} from './db-reader/db-reader.service';
import {MandantenService} from './mandanten/mandanten.service';
import {ContentBlockService} from './prozesse/contentBlock.service';
import {ApiCallService} from './api/api-call.service';
import {StateService} from './app/state.service';
import {GuardsCheckStart, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {RouterService} from './navigation/router.service';
import {FlexLinkService} from './navigation/flexLink.service';
import {KundeService} from './kunden/kunde.service';
import barriereFreiheitConfig from '../module/obs.barrierefreiheit/configs/barrierefreiheit.config.json';

@Injectable()
export class StartupService {

  constructor(
    private apiCallService: ApiCallService,
    private dbReaderService: DbReaderService,
    private mandantenService: MandantenService,
    private kundenService: KundeService,
    private contentblockService: ContentBlockService,
    private stateService: StateService,
    private router: Router,
    private routerService : RouterService,
    private flexLinkService: FlexLinkService,
  ) {}

  public initMandant(): Promise<boolean>{
    return new Promise((resolve) => {
      this.dbReaderService.get('aktiv', 'Mandant').subscribe(_id => {
        if (!_id) {
          const parameter = { mandantId: environment.mandant_id }
          this.apiCallService.request('/public', 'mandant/get', parameter).subscribe((mandant: any) => {
            this.mandantenService.mandant_id = new BehaviorSubject(environment.mandant_id)
            zip(
              this.contentblockService.contentBlockAktualisieren(mandant.sonderKonfiguration.API_1_5.contentBlockListe),
              this.dbReaderService.addV2(mandant, environment.mandant_id, 'Mandant'),
              this.dbReaderService.addV2(environment.mandant_id, 'aktiv', 'Mandant')
            ).subscribe(() => {
              this.stateService.mandant.next(mandant)
              resolve(true)
            })
          })
        } else {
          this.dbReaderService.get(_id, 'Mandant').subscribe(mandant => {
            this.mandantenService.mandant_id = new BehaviorSubject(_id)
            this.stateService.mandant.next(mandant)
            resolve(true)
          })
        }
      })
    })
  }

  public initKunde(){
    return new Promise((resolve) => {
      this.kundenService._kunde_get().subscribe(_id => {
        this.kundenService.kunde = !!_id
      })
      resolve(true)
    })
  }

  public initBarriereFreihheit(){
    this.dbReaderService.get('barrierefreiheit', 'Options').subscribe(barriereFreiheit => {
      if (!barriereFreiheit){
        this.dbReaderService.add(barriereFreiheitConfig, 'barrierefreiheit', 'Options')
      }
    })
  }

  public routen(){
    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart){
        this.routerService.mitteilungWbpAus()
      }
      if (event instanceof NavigationStart) {
        this.routerService.navCounter()
      }
      if (event instanceof NavigationEnd){
        this.routerService.revisionsKontrolle(this.router.url.split('/')[1])
        this.routerService.regLoeschen()
        this.flexLinkService.flexLinkSpeichern()
      }
    })
  }
}
